var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "date",
    transform: "translate(10528 -15202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_12_",
    "data-name": "calendar (12)",
    transform: "translate(-10529 15202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    transform: "translate(3 4)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 17,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_160",
    "data-name": "Line 160",
    y2: 4,
    transform: "translate(18 2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    "data-name": "Line 161",
    y2: 4,
    transform: "translate(8 2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_162",
    "data-name": "Line 162",
    x2: 20,
    transform: "translate(3 10)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 24,
    height: 24,
    transform: "translate(-10528 15202)",
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/date.3320354c2e5cfe1e65a869adb913ddac.svg";